import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Auth plumbing, never a post-login destination. `/redirect` is the damaging
 * one: this component is also the unauthenticated catch-all, so a signed-out
 * visit to `/redirect` lands here with that pathname — storing it makes
 * `/redirect` redirect to itself, spend the stored path, and fall through to
 * the default landing route.
 */
const NON_DESTINATION_PATHS = ["/login", "/redirect", "/logout", "/oauth"];

// The deployment's own hostname, from per-deployment config rather than a
// hard-coded domain, so white-label custom domains keep their deep links.
const APP_HOSTNAME = (() => {
  try {
    return new URL(process.env.REACT_APP_URL ?? "").hostname;
  } catch {
    return null;
  }
})();

export default function Login() {
  const navigate = useNavigate();

  useEffect(() => {
    const baseUrl = process.env.REACT_APP_FRONTEGG_URL;
    let url = `${baseUrl}/oauth/account/login`;

    // Save current path, unless it's plumbing: callers that gate on a session
    // (`/activate`, ProtectedRoute) set the key themselves before handing off.
    if (
      window.location.hostname === APP_HOSTNAME ||
      window.location.hostname === "localhost"
    ) {
      const fullPath = window.location.pathname + window.location.search;
      const isPlumbing = NON_DESTINATION_PATHS.some((path) =>
        fullPath.startsWith(path),
      );
      if (!isPlumbing) {
        localStorage.setItem("_REDIRECT_AFTER_LOGIN_", fullPath);
      }
    }

    // Build query params array
    const params = [];
    if (process.env.REACT_APP_FRONTEGG_APP_ID) {
      params.push(`appId=${process.env.REACT_APP_FRONTEGG_APP_ID}`);
    }

    // Append query parameters if any exist
    if (params.length > 0) {
      url += `?${params.join("&")}`;
    }

    window.location.replace(url);
  }, [navigate]);

  return null;
}
